/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimCenterWithBookables } from './ClaimCenterWithBookables';
import {
    ClaimCenterWithBookablesFromJSON,
    ClaimCenterWithBookablesFromJSONTyped,
    ClaimCenterWithBookablesToJSON,
} from './ClaimCenterWithBookables';

/**
 * Collection of claim centers with their bookable resource IDs
 * @export
 * @interface ClaimCentersWithBookables
 */
export interface ClaimCentersWithBookables {
    /**
     * 
     * @type {Array<ClaimCenterWithBookables>}
     * @memberof ClaimCentersWithBookables
     */
    claimCenters: Array<ClaimCenterWithBookables>;
}

/**
 * Check if a given object implements the ClaimCentersWithBookables interface.
 */
export function instanceOfClaimCentersWithBookables(value: object): value is ClaimCentersWithBookables {
    if (!('claimCenters' in value) || value['claimCenters'] === undefined) return false;
    return true;
}

export function ClaimCentersWithBookablesFromJSON(json: any): ClaimCentersWithBookables {
    return ClaimCentersWithBookablesFromJSONTyped(json, false);
}

export function ClaimCentersWithBookablesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCentersWithBookables {
    if (json == null) {
        return json;
    }
    return {
        
        'claimCenters': ((json['claimCenters'] as Array<any>).map(ClaimCenterWithBookablesFromJSON)),
    };
}

export function ClaimCentersWithBookablesToJSON(value?: ClaimCentersWithBookables | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimCenters': ((value['claimCenters'] as Array<any>).map(ClaimCenterWithBookablesToJSON)),
    };
}

